// Types
import { RobotRegFormType } from '../../types/RobotRegFormType';

// Shared
import { AxiosAPI } from '../../../../shared/utils/apiRequest';

export const postRobotRegFormApi = {
  postRobotRegForm: async (robotRegForm: RobotRegFormType): Promise<void> => {
    try {
      const response = await AxiosAPI.post('/post-robot-reg-form', robotRegForm);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  sendRegSuccessEmail: async (robotRegForm: RobotRegFormType): Promise<void> => {
    try {
      const response = await AxiosAPI.post('/send-success-email', robotRegForm);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};